import PropTypes from "prop-types";
import {Input} from "reactstrap";

// Helper function to get the contract number
const getContractNumber = (type, data) => {
  return type === "Incoming"
    ? data?.original?.contract_number
    : data?.original?.deal_number;
};

// Helper function to get the balance group
const getBalanceGroup = (data) => {
  return data?.original?.balance_group_name;
};

// Helper function to get the UOM
const getUOM = (type, data) => {
  return type === "Incoming" && data?.original?.product_qty_uom;
};

const Checkbox = ({row, table, type, otherRows, otherData}) => {
  const isOtherRows = Object.keys(otherRows).length > 0;
  const isOtherData = Object.keys(otherRows)
    .map((index) => Number(index))
    .map((index) => otherData[index]);

  const selectedOtherData =
    type === "Incoming"
      ? isOtherData?.find((item) => item?.deal_number)?.deal_number
      : isOtherData?.find((item) => item?.contract_number)?.contract_number;

  const isSelected = row.getIsSelected();
  const isSomeRowsSelected = table.getIsSomeRowsSelected();

  const selectedRowData = table
    .getSelectedRowModel()
    .rows?.find((item) => getContractNumber(type, item));

  const selectedRowContractNumber = getContractNumber(type, selectedRowData);
  const rowContractNumber = getContractNumber(type, row);

  const selectedRowBalanceGroup = getBalanceGroup(selectedRowData);
  const rowBalanceGroup = getBalanceGroup(row);

  const selectedRowUOM = getUOM(type, selectedRowData);
  const rowUOM = getUOM(type, row);

  const handleChange = row.getToggleSelectedHandler();

  const isDisabled =
    (isSomeRowsSelected &&
      !isSelected &&
      selectedRowContractNumber &&
      rowContractNumber &&
      (selectedRowContractNumber !== rowContractNumber ||
        selectedRowBalanceGroup !== rowBalanceGroup ||
        (type === "Incoming" && selectedRowUOM !== rowUOM))) ||
    (isOtherRows &&
      selectedOtherData &&
      rowContractNumber &&
      selectedOtherData !== rowContractNumber);

  return (
    <Input
      type="checkbox"
      checked={isSelected}
      onChange={handleChange}
      disabled={isDisabled}
    />
  );
};

Checkbox.propTypes = {
  row: PropTypes.object,
  table: PropTypes.object,
  type: PropTypes.string,
  otherRows: PropTypes.object,
  otherData: PropTypes.array,
};

export default Checkbox;
